import type { ReactNode } from "react";

const URL_NO_TEXTO = /https?:\/\/[^\s]+/g;
// Ponto, vírgula e aspas no fim fazem parte do texto, não do endereço.
const PONTUACAO_FINAL = /[.,;:}"'”’]+$/;
// Parêntese e colchete podem ser da própria URL (".../Foo_(bar)") ou do texto
// em volta ("(veja https://a.com/x)"). Só saem do fim quando sobrou fechamento.
const PARES_DE_FECHAMENTO = [
  [")", "("],
  ["]", "["],
];

const contar = (texto: string, alvo: string) => texto.split(alvo).length - 1;

function tirarPontuacaoFinal(endereco: string): string {
  let fim = endereco.replace(PONTUACAO_FINAL, "");
  let mudou = true;
  while (mudou) {
    mudou = false;
    for (const [fecha, abre] of PARES_DE_FECHAMENTO) {
      if (fim.endsWith(fecha) && contar(fim, fecha) > contar(fim, abre)) {
        fim = fim.slice(0, -1);
        mudou = true;
      }
    }
  }
  return fim;
}

// O additionalInfo vem da transportadora como texto puro e às vezes traz link
// ("Prazo de guarda dos Correios: https://..."). Devolve o texto com cada
// endereço http(s) como link, sem innerHTML.
export function textoComLinks(texto: string): ReactNode {
  const nos: ReactNode[] = [];
  let ultimo = 0;
  for (const achado of texto.matchAll(URL_NO_TEXTO)) {
    const inicio = achado.index ?? 0;
    const endereco = tirarPontuacaoFinal(achado[0]);
    if (inicio > ultimo) nos.push(texto.slice(ultimo, inicio));
    nos.push(
      <a
        key={inicio}
        href={endereco}
        target="_blank"
        rel="noopener noreferrer"
        className="break-all font-semibold text-[#C2410C] hover:underline"
      >
        {endereco}
      </a>
    );
    ultimo = inicio + endereco.length;
  }
  if (ultimo < texto.length) nos.push(texto.slice(ultimo));
  return nos;
}
